import { render, staticRenderFns } from "./OrderShipmentDetails.vue?vue&type=template&id=481c21b1&scoped=true&"
import script from "./OrderShipmentDetails.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c21b1",
  null
  
)

export default component.exports